import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const GET_PENDING_TASK_BEATS_COUNT_QUERY = gql`
  query Eager_GetPendingTaskBeatsCount($filter: TaskEntryFilter) {
    taskEntriesCount(filter: $filter, approvalStatus: PENDING)
      @connection(key: "pendingTaskBeatsCount", filter: ["filter"])
  }
`;

export const usePendingTaskBeatCount = ({ filter }) => {
  const { data, loading, refetch } = useQuery(
    GET_PENDING_TASK_BEATS_COUNT_QUERY,
    {
      variables: {
        filter
      },
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    count: data && data.taskEntriesCount,
    loading,
    refetch
  };
};

export const updatePendingTaskBeatCount = ({ cache, filter, offset }) => {
  const { taskEntriesCount } = cache.readQuery({
    query: GET_PENDING_TASK_BEATS_COUNT_QUERY,
    variables: {
      filter
    }
  });

  cache.writeQuery({
    query: GET_PENDING_TASK_BEATS_COUNT_QUERY,
    variables: {
      filter
    },
    data: {
      taskEntriesCount: Math.max(taskEntriesCount + offset, 0)
    }
  });
};
